module.exports = __webpack_public_path__ + "img/ZM.927f193f.svg";